var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgTreeMapChart = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3A312A;}\r\n\t.st1{fill:#FCE8CB;}\r\n\t.st2{fill:#8AC5DC;}\r\n\t.st3{fill:#ED6E7A;}\r\n\t.st4{fill:#D7E057;}\r\n\t.st5{fill:#87796F;}\r\n\t.st6{fill:#695B51;}\r\n\t.st7{fill:#EF6D7A;}\r\n\t.st8{fill:#D6DF58;}\r\n\t.st9{fill:#6A5C52;}\r\n\t.st10{fill:#F16C7A;}\r\n\t.st11{fill:#8AC6DD;}\r\n\t.st12{fill:#D34E5C;}\r\n\t.st13{fill:#B9C239;}\r\n\t.st14{fill:#6CA8BF;}\r\n\t.st15{fill:#89C4DB;}\r\n\t.st16{fill:#D5DE58;}\r\n\t.st17{fill:#DECAAD;}\r\n\t.st18{fill:#D5DC57;}\r\n\t.st19{fill:#8AC3DA;}\r\n\t.st20{fill:#D4DB56;}\r\n\t.st21{fill:#EA6D7A;}\r\n\t.st22{fill:#FAE6CA;}\r\n\t.st23{fill:#EB6E7A;}\r\n\t.st24{fill:#F8E4C8;}\r\n\t.st25{fill:#E96C7A;}\r\n\t.st26{fill:#8AC2D9;}\r\n\t.st27{fill:#E86C7A;}\r\n\t.st28{fill:#8AC1D8;}\r\n\t.st29{fill:#D4DA55;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 100.5,
    className: "st7",
    width: 55.5,
    height: 139
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.5,99H184c-0.829,0-1.5,0.671-1.5,1.5v139c0,0.829,0.671,1.5,1.5,1.5h55.5c0.829,0,1.5-0.671,1.5-1.5 v-139C241,99.671,240.329,99,239.5,99z M238,238h-52.5V102H238V238z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "16.5,100.5 16.5,133.886 16.5,148.114 16.5,239.5 128,239.5 128,100.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,99H16.5c-0.829,0-1.5,0.671-1.5,1.5v33.386c0,0.829,0.671,1.5,1.5,1.5s1.5-0.671,1.5-1.5V102h108.5v136 H18v-89.886c0-0.829-0.671-1.5-1.5-1.5s-1.5,0.671-1.5,1.5V239.5c0,0.829,0.671,1.5,1.5,1.5H128c0.829,0,1.5-0.671,1.5-1.5v-139 C129.5,99.671,128.829,99,128,99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    className: "st15",
    width: 111.5,
    height: 84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,15H16.5c-0.829,0-1.5,0.671-1.5,1.5v84c0,0.829,0.671,1.5,1.5,1.5H128c0.829,0,1.5-0.671,1.5-1.5v-84 C129.5,15.671,128.829,15,128,15z M126.5,99H18V18h108.5V99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 100.5,
    className: "st5",
    width: 56,
    height: 139
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,99h-56c-0.829,0-1.5,0.671-1.5,1.5v139c0,0.829,0.671,1.5,1.5,1.5h56c0.829,0,1.5-0.671,1.5-1.5v-139 C185.5,99.671,184.829,99,184,99z M182.5,238h-53V102h53V238z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "174.352,16.5 160.649,16.5 128,16.5 128,100.5 239.5,100.5 239.5,16.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.5,15h-65.148c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5H238v81H129.5V18h31.149 c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H128c-0.829,0-1.5,0.671-1.5,1.5v84c0,0.829,0.671,1.5,1.5,1.5h111.5 c0.829,0,1.5-0.671,1.5-1.5v-84C241,15.671,240.329,15,239.5,15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 102,
    className: "st12",
    width: 15,
    height: 136
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 18,
    className: "st17",
    width: 15,
    height: 81
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTreeMapChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tree-map-chart.87f54376.svg";
export { ForwardRef as ReactComponent };